import React from 'react';
import { PropertyGroup } from './PropertyGroup';
import { DefaultValueInput } from '../PropertyInputs';

/**
 * Default value property component - supports all field types that can have default values
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const DefaultValueProperty = _ref => {
  let {
    field,
    updateField,
    selectedField
  } = _ref;
  // Exclude container/layout fields that don't have meaningful default values
  // Also exclude fields that have their own default value components
  const excludedTypes = ['section', 'tabs', 'columns', 'divider', 'heading', 'paragraph', 'select', 'radio', 'checkbox', 'switch', 'repeater', 'tel', 'file', 'attachment', 'image', 'signature', 'hidden'];
  if (excludedTypes.includes(field.type)) {
    return null;
  }

  // Handle special field types with custom inputs
  if (field.type === 'currency' || field.type === 'price') {
    return /*#__PURE__*/_jsx(PropertyGroup, {
      label: "Default Value",
      children: /*#__PURE__*/_jsx("input", {
        type: "number",
        step: field.type === 'price' && field.decimalPlaces ? `0.${'0'.repeat(field.decimalPlaces - 1)}1` : 'any',
        value: field.defaultValue || '',
        onChange: e => updateField(selectedField, {
          defaultValue: e.target.value ? parseFloat(e.target.value) : ''
        }),
        className: "property-input",
        placeholder: "Enter default value"
      })
    });
  }
  if (field.type === 'rating') {
    const maxRating = field.maxRating || 5;
    return /*#__PURE__*/_jsx(PropertyGroup, {
      label: "Default Value",
      children: /*#__PURE__*/_jsx("input", {
        type: "number",
        min: "0",
        max: maxRating,
        value: field.defaultValue || '',
        onChange: e => updateField(selectedField, {
          defaultValue: e.target.value ? parseInt(e.target.value) : ''
        }),
        className: "property-input",
        placeholder: `Enter default rating (0-${maxRating})`
      })
    });
  }
  if (field.type === 'tags') {
    // Tags default value should be stored as comma-separated string
    // TagsField component will parse it automatically
    const defaultValue = Array.isArray(field.defaultValue) ? field.defaultValue.join(',') : field.defaultValue || '';
    return /*#__PURE__*/_jsxs(PropertyGroup, {
      label: "Default Value",
      children: [/*#__PURE__*/_jsx("input", {
        type: "text",
        value: defaultValue,
        onChange: e => {
          // Store as raw string - allow user to type commas freely
          // TagsField will parse comma-separated values automatically
          updateField(selectedField, {
            defaultValue: e.target.value
          });
        },
        className: "property-input",
        placeholder: "Enter tags (comma-separated)"
      }), /*#__PURE__*/_jsx("p", {
        className: "help-text",
        children: "Enter tags separated by commas (e.g., \"tag1, tag2, tag3\")"
      })]
    });
  }

  // Use DefaultValueInput for standard input fields
  return /*#__PURE__*/_jsx(PropertyGroup, {
    label: "Default Value",
    children: /*#__PURE__*/_jsx(DefaultValueInput, {
      field: field,
      value: field.defaultValue || '',
      onChange: value => updateField(selectedField, {
        defaultValue: value
      })
    })
  });
};